<template>
    <span class="check-session"></span>
</template>

<script lang="ts" setup>
    const router = useRouter()
    import JwtService from '@/core/services/JwtService'
    const apiClient = useApiClient()
    const getExpireTime = (token) => {
        const decode = JSON.parse(atob(token.split('.')[1]));
        return decode.exp * 1000 - Date.now();
    }
    const isMobile = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1024;
    }
    const checkToken = () => {
        try {
            var expiredTime = getExpireTime(JwtService.getToken());
            //console.log(expiredTime - 1000 * 60 * 5)
            if (expiredTime < 1000 * 60 * 5) {
                apiClient.refreshToken().then((res) => {
                    if (res.success && res.data && res.data.token) {
                        JwtService.saveToken(res.data.token);
                    } else {
                        JwtService.destroyToken();
                        window.location.href = '/account/login';
                        return Promise.reject()
                    }
                }).catch(err => {
                    window.location.href = '/account/login';
                    JwtService.destroyToken()
                    return Promise.reject(err)
                });
            }
        } catch (e) {
            window.location.href = '/account/login';
        }
    }
    onMounted(() => {
        if (isMobile()) {
            router.push('/app');
        } else {
            checkToken();
            //each 5s
            setInterval(() => {
                checkToken();
            }, 5000);
        }
    })
</script>
